import { render } from "./DashboardBlock.vue?vue&type=template&id=babe0770&ts=true"
import script from "./DashboardBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardBlock.vue?vue&type=script&lang=ts"

import "./DashboardBlock.vue?vue&type=style&index=0&id=babe0770&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__